import { useRecoilState } from "recoil";
import { filtros } from "../atom";

const useFiltrosState = () => {
    return useRecoilState(filtros);
};

export default useFiltrosState;